/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "landing_pad";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface TrackLandingPadRequestSource {
}

export enum TrackLandingPadRequestSource_Enum {
  UNKNOWN = 0,
  SETUP_FLIGHT = 1,
  UNRECOGNIZED = -1,
}

export function trackLandingPadRequestSource_EnumFromJSON(object: any): TrackLandingPadRequestSource_Enum {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return TrackLandingPadRequestSource_Enum.UNKNOWN;
    case 1:
    case "SETUP_FLIGHT":
      return TrackLandingPadRequestSource_Enum.SETUP_FLIGHT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TrackLandingPadRequestSource_Enum.UNRECOGNIZED;
  }
}

export function trackLandingPadRequestSource_EnumToJSON(object: TrackLandingPadRequestSource_Enum): string {
  switch (object) {
    case TrackLandingPadRequestSource_Enum.UNKNOWN:
      return "UNKNOWN";
    case TrackLandingPadRequestSource_Enum.SETUP_FLIGHT:
      return "SETUP_FLIGHT";
    case TrackLandingPadRequestSource_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseTrackLandingPadRequestSource(): TrackLandingPadRequestSource {
  return {};
}

export const TrackLandingPadRequestSource = {
  encode(_: TrackLandingPadRequestSource, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TrackLandingPadRequestSource {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTrackLandingPadRequestSource();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): TrackLandingPadRequestSource {
    return {};
  },

  toJSON(_: TrackLandingPadRequestSource): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<TrackLandingPadRequestSource>, I>>(base?: I): TrackLandingPadRequestSource {
    return TrackLandingPadRequestSource.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TrackLandingPadRequestSource>, I>>(_: I): TrackLandingPadRequestSource {
    const message = createBaseTrackLandingPadRequestSource();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
